<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <notice-for-decision>
        </notice-for-decision> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import noticeForDecision from './todo-notice-for-decision'
export default {
    components: {
        noticeForDecision
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-notice-for-decision.vue